module.exports = "/virtual-football-league/img/video/result-score.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/result-score.png
// module id = 358
// module chunks = 4